<div class="idp-form-grouped">
  <input
    aria-label="Demo input"
    autocomplete="off"
    class="idp-input"
    name=""
    required
    type="password"
  />
  <span class="idp-input--bar" hidden></span>
  <label class="idp-label">Demo Label</label>
  <button (click)="clickEvent()" class="idp-input--toggle">
    <span class="sr-only">Search</span>
    <i
      [ngClass]="{
        'idp-icon-eye-on': isToggleIcon === true,
        'idp-icon-eye-off': isToggleIcon === false
      }"
      aria-hidden="true"
      class="idp-icon-eye-on"
    ></i>
  </button>
</div>
